module.exports = __webpack_public_path__ + "static/img/school-11.45a819d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-11.png
// module id = HnRZ
// module chunks = 1